import { defaultCopy, defaultImages } from './values';

const getValue = (key, defaultValues, overrides) => {
  if (overrides && overrides[key]) return overrides[key];
  return defaultValues[key];
};

export const getCopy = (key, overrides = undefined) =>
  getValue(key, defaultCopy, overrides);
export const getImage = (key, overrides) =>
  getValue(key, defaultImages, overrides);
